import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.ChangeOwnership.IRequest;
type Response = Api.Core.Claim.ChangeOwnership.IResponse;
type Headers = Api.Core.Claim.ChangeOwnership.IHeaders;
const url = '/api/Claims/Claim/ChangeOwnership';
export default async function claimChangeOwnershipApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
